<template>
    <div class="page dashboard product-category-dashboard">
      <div class="content">
        <div
          v-if="isActionMenuOpen"
          class="action-menu-backdroup"
          v-on:click="toggleActionMenu('')"
        ></div>
        <div class="title-bar">
          <p class="title">Setting, Homepage Category</p>
          <div class="group">
            <div class="btn new">
              <div class="icon"></div>
              <p class="label" v-on:click="toggleActionMenu('new')">
                Add New
              </p>
            </div>
          </div>
        </div>
        <ListingComponent
          model="data"
          :isLoading="false"
          :data="{data:data, pageMeta: pageMeta}"
          :query.sync="query"
          :refresh="getData"
          :toggleActionMenu="handleDataClick"
          :listingOptions="listingOptions"
          :deleteRecord="deleteData"
        />
      </div>
      <div :class="`action-menu ${isActionMenuOpen ? 'active' : ''}`">
        <div class="btn close" v-on:click="toggleActionMenu('')"></div>
        <SettingHomepageCategoryNew
          v-if="isActionMenuOpen === 'new' || isActionMenuOpen === 'edit'"
          :editItem="editItem"
          :addNewSuccess="addNewSuccess"
        />
        <!-- <EditCategory
          v-if="isActionMenuOpen === 'read'"
          :categoryGroup="focusedCategoryGroup"
          :editCategory="editCategory"
        /> -->
      </div>
    </div>
  </template>
  
  <script>
  import ListingLoadingComponent from "../../components/ListingLoadingComponent";
  import TabBarLoadingComponent from "../../components/TabBarLoadingComponent";
  import ListingComponent from "../../components/ListingComponent";
  import TabBarComponent from "../../components/TabBarComponent";
  
  import SettingHomepageCategoryNew from "./SettingHomepageCategoryNew";
  export default {
    name: "SettingHomepageCategoryDashboard",
    components: {
      ListingLoadingComponent,
      TabBarLoadingComponent,
      ListingComponent,
      TabBarComponent,
      SettingHomepageCategoryNew,
    },
    data: function () {
        return {
            query: {
                order: "ASC",
                page: 1,
                limit: 10,
                sortBy: "",
                status: 0,
            },
            editItem: "",
            isActionMenuOpen: ""
        };
    },
    created() {
        this.getData();
    },
    methods: {
        addNewSuccess() {
          if(this.isActionMenuOpen == 'new') {
            this.query.page == 1;
            this.getData();
          }
          this.toggleActionMenu("");
        },
        toggleActionMenu(menu, editItem = null) {
          this.editItem = editItem;
          this.isActionMenuOpen = menu;
        },
        handleDataClick(action, payload) {
            if(action == 'edit') {
              this.toggleActionMenu('edit', payload)
            }
        },
        getData() {
            this.$store.dispatch("getSettingHomepageCategory", {
              ...this.query
            });
        },
        deleteData(item) {
            const confirmed = confirm('Are you sure you want to delete this?')
            
            if(confirmed) {
                this.$store.dispatch("deleteSettingHomepageCategory", {
                    _id: item._id
                });
            }
        },
    },
    watch: {
        query: {
            deep: true,
            handler: function () {
                if (this.query.page >= 1) {
                    this.getData();
                }
            },
        }
    },
    computed: {
        pageMeta() {
            return this.$store.state.setting.homepageCategory.pageMeta || [];
        },
        data() {
            return this.$store.state.setting.homepageCategory.data || [];
        },
        listingOptions() {
            return {
                hasSelected: false,
                hasNo: true,
                actions: ['delete', 'edit'],
                queryOptions: {
                    sortBy: [],
                    sortDirection: [],
                },
                schema: [
                    {
                        label: "category",
                        key: 'category',
                        value: (record) => {
                            if(!record.category) {
                                return 'N/A';
                            }

                            return record.category.en;
                        },
                    },
                    {
                        label: "Order",
                        key: 'order'
                    }
                ],
            };
        }
    },
  };
  </script>
  
  <style>
  </style>